import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Años sintiendo que podés más pero sin saber cómo desbloquearlo', 'Estrés financiero que no para aunque trabajes más', 'Relaciones que drenan en lugar de potenciar', 'Ansiedad que aparece justo cuando más necesitás claridad', 'Decisiones tomadas desde el miedo en lugar de la soberanía', 'Sensación de que el contexto argentino siempre gana'];
  return <section className="py-20 md:py-32 px-4 bg-dark-card/30" data-id="element-206">
      <div className="max-w-4xl mx-auto" data-id="element-207">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-208">
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-8 text-white leading-tight" data-id="element-209">
            ¿Cuánto tiempo más vas a seguir esperando que el contexto cambie?
          </h2>
          <p className="text-xl text-gray-300 mb-4" data-id="element-210">
            Sentís que tenés más para dar pero algo te frena. Tal vez hace
            meses. Tal vez hace años.
          </p>
          <p className="text-xl text-gray-300" data-id="element-211">
            No es falta de capacidad. No es el país. Es que nadie te enseñó a
            reprogramar el sistema operativo que corre tu vida.
          </p>
        </motion.div>

        <div className="space-y-4 mb-16" data-id="element-212">
          {points.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 p-4 rounded-lg bg-dark border border-dark-border/50 hover:border-red-900/30 transition-colors" data-id="element-213">
              <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-214" />
              <span className="text-lg text-gray-200" data-id="element-215">{point}</span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center p-8 rounded-2xl bg-gradient-to-b from-gold/10 to-transparent border border-gold/20" data-id="element-216">
          <h3 className="text-2xl md:text-4xl font-heading font-bold text-gold-light" data-id="element-217">
            ¿Y si el problema no fuera el contexto sino el software con el que
            lo procesás?
          </h3>
        </motion.div>
      </div>
    </section>;
}